var _path, _path2, _path3, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trash",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.667,
    height: 22.667,
    viewBox: "0 0 17.667 22.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_557",
    "data-name": "Trazado 557",
    d: "M14.834,23.834H3.167A1.666,1.666,0,0,1,1.5,22.167V10.5h15V22.167A1.666,1.666,0,0,1,14.834,23.834Z",
    transform: "translate(-0.167 -1.667)",
    fill: "none",
    stroke: "gray",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_558",
    "data-name": "Trazado 558",
    d: "M16.75,9.5H.917A.417.417,0,0,1,.5,9.083V5.75A1.25,1.25,0,0,1,1.75,4.5H15.917a1.25,1.25,0,0,1,1.25,1.25V9.083A.417.417,0,0,1,16.75,9.5Z",
    transform: "translate(0 -0.667)",
    fill: "none",
    stroke: "gray",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_559",
    "data-name": "Trazado 559",
    d: "M13.833,3.833H5.5v-2.5A.834.834,0,0,1,6.333.5H13a.834.834,0,0,1,.833.833Z",
    transform: "translate(-0.833)",
    fill: "none",
    stroke: "gray",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_121",
    "data-name": "L\\xEDnea 121",
    y1: 7.751,
    transform: "translate(5.501 11.357)",
    fill: "none",
    stroke: "gray",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_122",
    "data-name": "L\\xEDnea 122",
    y1: 7.751,
    transform: "translate(8.833 11.357)",
    fill: "none",
    stroke: "gray",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_123",
    "data-name": "L\\xEDnea 123",
    y1: 7.751,
    transform: "translate(12.166 11.357)",
    fill: "none",
    stroke: "gray",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.84397bf036d6231d7533a7023780e698.svg";
export { ForwardRef as ReactComponent };